import * as segmentio from 'rp-analytics';

export default function analyticsPage() {
    segmentio.setCommonTraits({
        [segmentio.TRAIT_SITE_SECTION]: 'Non-runners',
        [segmentio.TRAIT_SITE_SUB_SECTION_1]: null,
        [segmentio.TRAIT_SITE_SUB_SECTION_2]: null,
    });

    segmentio.page();
}



// WEBPACK FOOTER //
// ./src/js/analyticsPage.js